export const startTimes: string[] = [
  "0800",
  "0830",
  "0900",
  "0930",
  "1000",
  "1030",
  "1100",
  "1130",
  "1200",
  "1230",
  "1300",
  "1330",
  "1400",
  "1430",
  "1500",
  "1530",
  "1600",
  "1630",
  "1700",
  "1730",
  "1800",
  "1830",
  "1900",
  "1930",
  "2000",
  "2030",
  "2100",
  "2130",
  "2200",
];

export const startTimeIndex = startTimes.reduce(
  (obj, value, index) => ({
    ...obj,
    [value]: index,
  }),
  {}
);

export const getTimeIndex = ({ time_use_start, time_use_end }) => {
  let startIdx =
    startTimeIndex[time_use_start] !== undefined
      ? startTimeIndex[time_use_start]
      : 0;
  let endIdx =
    startTimeIndex[time_use_end] !== undefined
      ? startTimeIndex[time_use_end] - 1
      : startTimes.length - 2;
  return [startIdx, endIdx];
};



// WEBPACK FOOTER //
// ./src/app/member/rental/rental.ts